import { DownloadPlatformPageService } from './download.platform.page.service';
import moment, { Moment } from 'moment';
import { currentUrl, numberSystemDecimal, searchParams, webApi } from '../../common/consts';
import { SwitcherComponent } from '../../base/switcher.component';
import {
    InterfacePlatform,
    InterfacePlatformAlphaItem, InterfacePlatformChange,
    InterfacePlatformItem
} from '../../interface/platform/interface.platform';
import { DownloadStore } from '../../store/download.store';
// import {DownloadTabs} from "../../components/download/download.tabs";

export class DownloadPlatformPage {
    private readonly platformsJson: HTMLInputElement | null;
    private readonly platformCurrentVersion: HTMLElement | null;
    private readonly platformContentWrap: HTMLElement | null;
    private readonly platformDescription: HTMLElement | null;
    private readonly platformContent: HTMLElement | null;
    private platformIdWithLoadedData: number;
    private queryParams: Record<string, number | string>
    private currentUrl: URL;
    constructor(
      private loader: HTMLElement | null,
      private switchers: HTMLElement[],
      private downloadStore: DownloadStore | null = null,
    ) {
        this.platformsJson = document.querySelector('[data-platforms-json]');
        this.platformCurrentVersion = document.querySelector('[data-platform-current-version]');
        this.platformContentWrap = document.querySelector('[data-platform-content-wrap]');
        this.platformDescription = document.querySelector('[data-platform-description]');
        this.platformContent = document.querySelector('[data-platform-content]');
        this.platformIdWithLoadedData = 0;
        this.currentUrl = currentUrl;

        this.queryParams = {};
        const platformId = searchParams.get('platformId');
        if (platformId) {
            this.platformIdWithLoadedData = parseInt(platformId, numberSystemDecimal);
        }
        // if (this.platformsJson?.value && platformId) {
        //     const platforms = JSON.parse(this.platformsJson?.value).Platforms;
        //     const platform = platforms.find(
        //         (platform: InterfacePlatformAlphaItem) => platform.Id == parseInt(
        //             platformId, numberSystemDecimal
        //         ))
        //     if (platform) {
        //         DownloadTabs.setPlatformName(platform.Name);
        //     }
        //
        // }
    }

    public initialize(platformId: number): void {

        searchParams.set('platformId', platformId.toString());
        this.currentUrl.search = searchParams.toString();
        history.pushState(null, '', this.currentUrl.toString());
        this.queryParams.pageMedia = platformId;
        const downloadPlatformPageService = new DownloadPlatformPageService(this.loader);
        const platformIdQuery = searchParams.get('platformId');

        if (this.platformIdWithLoadedData !== platformId) {
            downloadPlatformPageService.getPlatform(platformId).then((data: InterfacePlatform | null) => {
                if (this.platformsJson && this.platformCurrentVersion && this.platformDescription && data) {
                    const rawVersionDate: Moment = moment(data.Items[0].VersionDate, 'DD.MM.YYYY HH:mm:ss');
                    const platforms = JSON.parse(this.platformsJson.value).Platforms

                    moment(rawVersionDate).format('DD.MM.YYYY');
                    this.platformCurrentVersion.innerHTML = `
                    Актуальная версия: ${data.Items[0].Version}
                    от ${moment(rawVersionDate).format('DD.MM.YYYY')} <span>|</span>`;
                    if (platforms && platforms.length > 0) {
                        this.platformDescription.innerHTML = platforms
                            .find(
                                (platform: InterfacePlatformAlphaItem) => platform.Id === platformId
                            )?.Description ?? '';
                    }

                    const selectedPlatform: InterfacePlatformAlphaItem = platforms
                        .find((platform: InterfacePlatformAlphaItem) => platform?.Id === platformId);
                    if (selectedPlatform) {
                        if (this.platformContentWrap) {
                            const modalButton = this.platformContentWrap.querySelector('[data-modal-open]')

                            modalButton?.setAttribute('data-modal-open', selectedPlatform.Name);
                        }
                    }

                    let platformContent = '';
                    data.Items.forEach((item: InterfacePlatformItem) => {

                        platformContent += `
                        <div class="mb-20">
                            <div class="download__tab-content-item">
                              <div>
                                <h4>${item.Title}</h4>
                                <div class="download__tab-content-toggle control-area" data-switcher-control>
                                  <p class="control-area__toggle-text">
                                    <span>Подробнее</span>
                                    <span>Скрыть подробности</span>
                                  </p>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="8" viewBox="0 0 15 8"
                                       fill="none">
                                    <path d="M1.5 1L7.5 7L13.5 1" stroke="#1D1C1C" stroke-width="2"
                                          stroke-linecap="round" stroke-linejoin="round"></path>
                                  </svg>
                                </div>
                                <div class="download__hidden-area hidden-area" data-switcher-content>
                                 <div class="mb-20"> <p>${item.Description}</p></div>
                                 <p class="size-mini">MD5(Хэш-сумма): ${item.Md5}</p>
                                </div>
                              </div>
                              <a href="${webApi}/WebApi/Platforms/Download/${item.Id}"
                                 class="button button__normal button__link">
                                Скачать
                              </a>
                            </div>
                        </div>
                    `
                    });

                    if (this.platformContent) {
                        this.platformContent.innerHTML = platformContent;
                        this.switchers.forEach((switcher: HTMLElement): void => {
                            new SwitcherComponent(switcher).initialize();
                        });
                    }
                }
                this.platformIdWithLoadedData = platformId;
            });
        }
        if (this.downloadStore) {
            this.downloadStore.setPlatformId(platformId);
        }
    }
}
